/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_TitleInputs */

const en_fc_home_review_title = /** @type {(inputs: Fc_Home_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft review: strengths and limits`)
};

/**
* | output |
* | --- |
* | "FilmCraft review: strengths and limits" |
*
* @param {Fc_Home_Review_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_title = /** @type {((inputs?: Fc_Home_Review_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_title(inputs)
});
export { fc_home_review_title as "fc.home.review.title" }